import { Button } from "@/components/common/Button";
import { env } from "@/config";
import { AnalyticsEvents } from "@/shared/utils/analytics/events";
import WebApp from "@twa-dev/sdk";
import { useTranslation } from "react-i18next";

const Support = () => {
  const { t } = useTranslation();

  const isMiniApp = !!WebApp.initData

  const goToSupport = () => {
    if (isMiniApp) {
      WebApp.openLink(env.supportLink);

      return;
    }
    window.location = env.supportLink;
  };

  return (
    <div className="flex flex-col gap-5 p-4 border-b border-divider box-content">
      <Button
        onClick={goToSupport}
        text={t("settings.support")}
        size="large"
        className="w-full"
        analyticsEvent={AnalyticsEvents.Settings.Support}
      />
      <p className="text-[0.8125rem] leading-[1rem] text-section-header-text px-4 text-center tracking-tighter">
        {t("settings.support_description")}
      </p>
    </div>
  );
};

export default Support;
